import { render, staticRenderFns } from "./EditPosition.vue?vue&type=template&id=40077a96&scoped=true"
import script from "./EditPosition.vue?vue&type=script&lang=js"
export * from "./EditPosition.vue?vue&type=script&lang=js"
import style0 from "./EditPosition.vue?vue&type=style&index=0&id=40077a96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40077a96",
  null
  
)

export default component.exports